import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/components/parts/header/deferred/index.ts